/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  GetIntermediaryAccreditationOrchestration,
  NotFoundErrorResult,
  ResultOfFitAndProperCheckViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    GetIntermediaryAccreditationOrchestrationFromJSON,
    GetIntermediaryAccreditationOrchestrationToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfFitAndProperCheckViewModelFromJSON,
    ResultOfFitAndProperCheckViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface FitAndProperGetIntermediaryAccreditationRequest {
    orchestration: GetIntermediaryAccreditationOrchestration;
}

/**
 * 
 */
export class FitAndProperApi extends runtime.BaseAPI {

    /**
     * Gets intermediary accreditation details.
     */
    async fitAndProperGetIntermediaryAccreditationRaw(requestParameters: FitAndProperGetIntermediaryAccreditationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfFitAndProperCheckViewModel>> {
        if (requestParameters.orchestration === null || requestParameters.orchestration === undefined) {
            throw new runtime.RequiredError('orchestration','Required parameter requestParameters.orchestration was null or undefined when calling fitAndProperGetIntermediaryAccreditation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/fit-and-proper`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetIntermediaryAccreditationOrchestrationToJSON(requestParameters.orchestration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfFitAndProperCheckViewModelFromJSON(jsonValue));
    }

    /**
     * Gets intermediary accreditation details.
     */
    async fitAndProperGetIntermediaryAccreditation(requestParameters: FitAndProperGetIntermediaryAccreditationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfFitAndProperCheckViewModel> {
        const response = await this.fitAndProperGetIntermediaryAccreditationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
